export default __webpack_public_path__ + "static/media/select-permissions.2b212056.png";